import React from "react";
import { IconSizeEnum } from "../../types/AppTypes";
import { IconManager } from "../core/IconManager/IconManager";
import { StyledStarFeedback } from "./StarFeedback.styled";
import { theme } from "../../constants/StyledComponents";
import { ReactComponent as FeedbackIcon } from "../../icons/feedback.svg";

type startFeedbackProps = {
  starNumber: number;
  starToFill: number;
};

export const StarFeedback = ({
  starNumber,
  starToFill,
}: startFeedbackProps) => {
  return (
    <StyledStarFeedback>
      {Array.from({ length: starNumber }).map((_, index) => {
        return (
          <IconManager
            key={`row-${index}`}
            size={IconSizeEnum.SMALL}
            color={theme.colors.purple}
            fill={
              index < starToFill ? theme.colors.purple : theme.colors.trasparent
            }
          >
            <FeedbackIcon />
          </IconManager>
        );
      })}
    </StyledStarFeedback>
  );
};
